'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DiscussionCard;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _renderIf = require('render-if');

var _renderIf2 = _interopRequireDefault(_renderIf);

var _lodash = require('lodash');

var _discussions = require('../api/discussions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
function DiscussionCard(_ref) {
	var participants = _ref.participants;
	var status = _ref.status;
	var onClick = _ref.onClick;
	var onStatusChange = _ref.onStatusChange;

	return _react2.default.createElement(
		'div',
		{ className: 'vtChat-DiscussionCard' },
		_react2.default.createElement(
			'button',
			{
				className: 'vtChat-DiscussionCard-title vtChat-Button',
				onClick: onClick
			},
			participants.map(function (participant) {
				return participant.firstName + ' ' + participant.lastName;
			}).join(', ')
		),
		(0, _renderIf2.default)(status === _discussions.Status.PENDING)(function () {
			return _react2.default.createElement(
				'button',
				{
					className: 'vtChat-DiscussionCard-action vtChat-Button',
					onClick: (0, _lodash.partial)(onStatusChange, _discussions.Status.OPEN)
				},
				_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'vtChat.DiscussionCard.action.open' })
			);
		}),
		(0, _renderIf2.default)(status === _discussions.Status.OPEN)(function () {
			return _react2.default.createElement(
				'button',
				{
					className: 'vtChat-DiscussionCard-action vtChat-Button',
					onClick: (0, _lodash.partial)(onStatusChange, _discussions.Status.CLOSED)
				},
				_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'vtChat.DiscussionCard.action.close' })
			);
		})
	);
}

DiscussionCard.propTypes = {
	participants: _react.PropTypes.array.isRequired,
	status: _discussions.StatusPropType.isRequired,
	onClick: _react.PropTypes.func,
	onStatusChange: _react.PropTypes.func
};

DiscussionCard.defaultProps = {
	onClick: _lodash.noop,
	onStatusChange: _lodash.noop
};